"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleUser = exports.StyleThumb = exports.StyleName = exports.StyleEmail = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-1p3n5ir-0"
})(["display:flex;align-items:center;padding-bottom:16px;border-bottom:1px solid ", ";margin-bottom:8px;font-family:Figtree;"], (0, _color.default)('gray-4'));
const StyleThumb = exports.StyleThumb = _styledComponents.default.div.withConfig({
  displayName: "StyleThumb",
  componentId: "sc-1p3n5ir-1"
})(["position:relative;"]);
const StyleUser = exports.StyleUser = _styledComponents.default.div.withConfig({
  displayName: "StyleUser",
  componentId: "sc-1p3n5ir-2"
})(["padding-left:12px;flex:1;overflow:hidden;"]);
const StyleName = exports.StyleName = _styledComponents.default.div.withConfig({
  displayName: "StyleName",
  componentId: "sc-1p3n5ir-3"
})(["font-size:1.6rem;"]);
const StyleEmail = exports.StyleEmail = _styledComponents.default.div.withConfig({
  displayName: "StyleEmail",
  componentId: "sc-1p3n5ir-4"
})(["font-size:1.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);